import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) { console.error("App crash:", error, info); }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream px-6" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <p className="font-serif text-4xl mb-4">S/ME</p>
            <p className="font-sans text-ink/70 mb-8">Something went wrong loading this page. A quick reload usually sorts it.</p>
            <button
              onClick={() => { window.location.href = "/"; }}
              className="bg-ink text-cream px-8 py-4 overline"
              data-testid="error-reload-btn"
            >
              Reload S/ME
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
